export default {
  STATUS: [
    { KEY: 0, VALUE: 'CRIADO' },
    { KEY: 1, VALUE: 'PERSO' },
    { KEY: 2, VALUE: 'INICIALIZADO' },
    { KEY: 3, VALUE: 'ATRIBUÍDO' },
    { KEY: 4, VALUE: 'BLOQUEADO' },
    { KEY: 5, VALUE: 'FRAGMENTADO' },
  ],

  TYPES: [
    { KEY: 0, VALUE: 'MIFARE CLASSIC' },
    { KEY: 1, VALUE: 'MIFARE PLUS' },
    { KEY: 2, VALUE: 'CIPURSE' },
    { KEY: 3, VALUE: 'CALYPSO' },
  ],

  DEVICE_TYPES: [
    { KEY: 0, VALUE: 'SMARTCARD', LABEL: 'CARTÃO' },
    { KEY: 1, VALUE: 'WEREABLE', LABEL: 'ACESSÓRIOS' },
    { KEY: 2, VALUE: 'PHONE', LABEL: 'TELEFONE CELULAR', IS_PHONE: true },
  ],
};

const CONST_TRANSPORT_CARD_OBJECT = {
  STATUS: {
    CREATED: { KEY: 0, VALUE: 'CRIADO' },
    PERSO: { KEY: 1, VALUE: 'PERSO' },
    INITIALIZED: { KEY: 2, VALUE: 'INICIALIZADO' },
    ASSIGNED: { KEY: 3, VALUE: 'ATRIBUÍDO' },
    BLOCKED: { KEY: 4, VALUE: 'BLOQUEADO' },
    FRAGMENTED: { KEY: 5, VALUE: 'FRAGMENTADO' },
  },
};

export { CONST_TRANSPORT_CARD_OBJECT };
